<script setup lang="ts">
import { computed } from 'vue'
import Skeleton from '@/components/ui/skeleton/Skeleton.vue'

const props = withDefaults(defineProps<{ words?: number; minCh?: number; maxCh?: number }>(), {
  words: 120,
  minCh: 2,
  maxCh: 11
})

function rng(seed: number) {
  let s = seed
  return () => (s = (s * 9301 + 49297) % 233280) / 233280
}
const rand = rng(42)

const widths = computed(() => {
  const out: number[] = []
  for (let i = 0; i < props.words; i++)
    out.push(Math.round(props.minCh + rand() * (props.maxCh - props.minCh)))
  for (let i = out.length - 12; i < out.length; i++)
    if (i >= 0) out[i] = Math.max(props.minCh, Math.floor(out[i] * 0.7))
  return out
})
</script>

<template>
  <div class="mb-px flex flex-wrap content-start leading-none" style="--overlap: 0.5px">
    <Skeleton
      v-for="(w, i) in widths"
      :key="i"
      :style="{ width: `${w * 0.5}rem` }"
      class="mb-2 h-[1em] rounded-none"
    />
  </div>
</template>
